/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Media_Source_CloudflareInputs */



/**
* | output |
* | --- |
* | "Cloudflare Stream" |
*
* @param {New_Project_Media_Source_CloudflareInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_media_source_cloudflare = /** @type {((inputs?: New_Project_Media_Source_CloudflareInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Media_Source_CloudflareInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cloudflare Stream")
	if (locale === "de") return /** @type {LocalizedString} */ ("Cloudflare Stream")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cloudflare Stream")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Cloudflare Stream")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cloudflare Stream")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Cloudflare Stream")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Cloudflare Stream")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Cloudflare Stream")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cloudflare Stream")
	return /** @type {LocalizedString} */ ("Cloudflare Stream")
});